const BYPASS_MODES = ['2', '3']

export const checkBypassMode = (utmBp: any): boolean => {
  if (utmBp && typeof utmBp === 'number') {
    return BYPASS_MODES.includes(String(utmBp))
  }
  return BYPASS_MODES.includes(utmBp)
}
